module.exports = __webpack_public_path__ + "static/media/Ndungu Thairu.63a2a07e.jpeg";